import React from "react";

import {
  INVENTORY_ACTIVITY_STATUS,
  INVENTORY_ACTIVITY_TYPES,
  POST_FINAL_STAGE_STATUS
} from "../data-handling/finance-inventory-constants";
import { IActivityDetail, IActivityItem } from "../data-handling/finance-inventory-types";
import { cloneDeep } from "lodash";

export function isGRN(activityType: string) {
  return Boolean(activityType === INVENTORY_ACTIVITY_TYPES.post_final_goods_received_note ||
    activityType === INVENTORY_ACTIVITY_TYPES.goods_received_note);
}

export const getStatusComponent = (status: string, itemObject?: IActivityItem | IActivityDetail) => {
  if (itemObject?.postFinalDate || isPostFinalApprovedActivity(itemObject as IActivityDetail)) {
    status = INVENTORY_ACTIVITY_STATUS.approved
  }

  const statusUpperCase = status?.toUpperCase();

  const isApproved = statusUpperCase === INVENTORY_ACTIVITY_STATUS.approved.toUpperCase();

  return (
    <span className={`text-[12px] font-500 ${isApproved ? "text-green-600" : "text-yellow-600"}`}>
      {isApproved ? "Approved" : "Pending"}
    </span>
  );
};

export const isPostFinalApprovedActivity = (
  activityDetail: IActivityDetail
) => {
  return (
    [
      INVENTORY_ACTIVITY_TYPES.post_final_transfer_ins,
      INVENTORY_ACTIVITY_TYPES.post_final_goods_received_note,
    ].includes(activityDetail?.activityType || "") &&
    activityDetail?.status === INVENTORY_ACTIVITY_STATUS.final
  );
};

export function arrayToMap<T extends Record<string, any>>(array: T[], id: keyof T): Record<string, T> | null {
  if (!array || array.length === 0) {
    return null;
  }

  return array.reduce((map: Record<string, T>, obj: T) => {
    map[String(obj[id])] = obj;
    return map;
  }, {});
};

export const getStatusStageComponent = (
  itemObject?: IActivityItem | IActivityDetail
) => {
  const postFinalStage = itemObject?.postFinalStage;
  const postFinalDate = itemObject?.postFinalDate;

  let label = "Pending";
  let colorClass = "text-yellow-600";

  if (postFinalStage === POST_FINAL_STAGE_STATUS.approved || postFinalDate) {
    label = "Approved";
    colorClass = "text-green-600";
  } else if (postFinalStage === POST_FINAL_STAGE_STATUS.rejected) {
    label = "Rejected";
    colorClass = "text-rede2574c";
  }  
  return (
    <span className={`text-[12px] font-500 ${colorClass}`}>
      {label}
    </span>
  );
};